import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'
import { apiV1 } from '../utils/constant';

/**
 * @function getDistribution
 * @desc 案件类型分布
 * @returns {Object}
 */
const getDistribution = (query) => {
  return axios
    .get(
      `${apiV1}/projects/${getProjectId()}/reports/order/distribution?${query}`
    )
    .then(checkResponse)
}

/**
 * @function getUcaseOrganizations
 * @desc 案件办理情况
 * @returns {Object}
 */
const getUcaseOrganizations = (query) => {
  return axios
    .get(
      `${apiV1}/projects/${getProjectId()}/reports/order/organizations?${query}`
    )
    .then(checkResponse)
}

const getTask = (projectid, taskid) => {
  return axios
    .get(`${apiV1}/projects/${projectid}/tasks/${taskid}/ucases/spec?view=web`)
    .then(checkResponse);
}
const isRepeated = (projectid, taskid, number) => {
  return axios
    .get(`${apiV1}/projects/${projectid}/tasks/${taskid}/ucases/index_quick?number=${number}`)
    .then(checkResponse);
}

const submitTui = (projectid,taskid,data) => {
  return axios
    .post(`${apiV1}/projects/${projectid}/tasks/${taskid}/ucases?platform=web`, { data })
    .then(checkResponse);
}

/**
 * @function postFile
 * @desc 上传图片(接诉即办)
 * @returns {Object}
 */
const postFile = (name, data) => {
  return axios
    .post(
      `${apiV1}/projects/${getProjectId()}/connection/fileStore?name=${name}`, data
    )
    .then(checkResponse)
}

/**
 * @function getFile
 * @desc 获取图片(接诉即办)
 * @returns {Object}
 */
const getFile = () => {
  return axios
    .get(`${apiV1}/projects/${getProjectId()}/connection/fileStore`)
    .then(checkResponse)
}

/**
 * @function organizationsExport
 * @desc 导出案件办理情况
 * @returns {Object}
 */
const organizationsExport = (query) => {
  return axios
    .get(
      `${apiV1}/projects/${getProjectId()}/reports/order/organizations/export?${query}`
    )
    .then(checkResponse)
}
export {
  getTask,
  isRepeated,
  submitTui,
  getDistribution,
  getUcaseOrganizations,
  postFile,
  getFile,
  organizationsExport
}
